import React, { useState } from 'react';
import {
  TextField,
  InputAdornment,
  useTheme,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import dayjs, { Dayjs } from 'dayjs';

interface SingleDatePickerMAIQProps {
  value: string | null;
  onChange: (date: string | null) => void;
  label?: string;
  placeholder?: string;
  size?: 'small' | 'medium';
  fullWidth?: boolean;
  disabled?: boolean;
  minDate?: Date;
  maxDate?: Date;
  error?: boolean;
  helperText?: string;
}

const SingleDatePickerMAIQ: React.FC<SingleDatePickerMAIQProps> = ({
  value,
  onChange,
  label,
  placeholder = 'Select date',
  size = 'small',
  fullWidth = true,
  disabled = false,
  minDate,
  maxDate,
  error = false,
  helperText,
}) => {
  const theme = useTheme();

  const handleDateChange = (date: Dayjs | null) => {
    if (date) {
      onChange(date.format('YYYY-MM-DD'));
    } else {
      onChange(null);
    }
  };

  const dayjsValue = value ? dayjs(value) : null;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={label}
        value={dayjsValue}
        onChange={handleDateChange}
        minDate={minDate ? dayjs(minDate) : undefined}
        maxDate={maxDate ? dayjs(maxDate) : undefined}
        disabled={disabled}
        slotProps={{
          textField: {
            size,
            fullWidth,
            placeholder,
            error,
            helperText,
            // InputProps: {
            //   endAdornment: (
            //     <InputAdornment position="end">
            //       <CalendarTodayIcon
            //         sx={{ color: 'text.secondary', fontSize: 20 }}
            //       />
            //     </InputAdornment>
            //   ),
            // },
            sx: {
              '& .MuiOutlinedInput-root': {
                borderRadius: 1,
                backgroundColor: 'background.paper',
                '&:hover fieldset': {
                  borderColor: theme.palette.secondary.main,
                },
                '&.Mui-focused fieldset': {
                  borderColor: theme.palette.secondary.main,
                },
              },
            },
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default SingleDatePickerMAIQ;
